export default "mdc-dialog-content {\n  padding: 0 24px;\n  font-size: 0.8em;\n}"